export default {
    name: ["", ""],
    logout: ["Log Out", "ចាកចេញ"],
    headTitle: ["DIGITAL PUBLIC SERVICE SYSTEM", "ប្រព័ន្ធផ្តល់សេវាសាធារណៈឌីជីថល"],
    system: ["Ministry of Industry, Science, Technology & Innovation", "ក្រសួងឧស្សាហកម្ម វិទ្យាសាស្រ្ត បច្ចេកវិទ្យា និងនវានុវត្តន៍"],
    startDate: ["Start Date", "ថ្ងៃចាប់ផ្តើម"],
    endDate: ["End Date", "ថ្ងៃបញ្ចប់"],
    active: ["Active", "ដំណើរការ"],
    showMore: ["Show more", "បង្ហាញបន្ថែម"],
    search: ["Search", "ស្វែងរក"],
    edit: ["Edit", "កែប្រែ"],
    enable: ["Enable", "ដាក់ដំណើរការ"],
    disable: ["Disable", "បញ្ចប់ដំណើរការ"],
    delete: ["Delete", "លុបចេញ"],
    cancel: ["Cancel", "បោះបង់"],
    statusAll: ["Status (All)", "ស្ថានភាព (ទាំងអស់)"],
    typeAll: ["Type (All)", "ប្រភេទ (ទាំងអស់)"],
    type: ["Type", "ប្រភេទ"],
    update: ["Update", "ធ្វើបច្ចុប្បន្នភាព"],
    all: ["All", "ទាំងអស់"],
    status: ["Status", "ស្ថានភាព"],
    action: ["Action", "សកម្មភាព"],
    lastUpdate: ["Last Updated", "កែប្រែចុងក្រោយ"],
    settings: ["System Settings", "ការកំណត់ប្រព័ន្ធ"],
    code: ["Code", "លេខកូដ"],
    home: ["Home", "ទំព័រដើម"],
    draftApp: ["Draft Applications", "ពាក្យស្នើសុំបានព្រាង"],
    submittedApp: ["Submitted Applications", "ពាក្យស្នើសុំបានស្នើ"],
    newForm: ["New Application Form", "ដាក់ពាក្យស្នើសុំថ្មី"],
    service_price: ["Price", "តម្លៃសេវា"],
    process_time: ["Process time", "រយៈពេលផ្តល់សេវា"],
    validity: ["Validity", "សុពលភាព"],
    day: ["days", "ថ្ងៃ"],
    cert_license: ["Certificates/Licenses", "វិញ្ញាបនបត្រ/អាជ្ញាប័ណ្ណ"],
    payment: ["Payments", "ប្រវត្តិបង់ប្រាក់"],
    document: ["Official Documents", "ឯកសារបទដ្ឋានគតិយុត្តិ"],
    feedback: ["Feedback", "ផ្តល់មតិយោបល់"],
    public_service: ["public service(s)", "សេវាសាធារណៈ"],
    goHome: ["Go Home", "ទៅកាន់ទំព័រដើម"],
    noExistForm: ["Public Service Data Form is not existed.", "មិនមានទម្រង់សម្រាប់សេវាសាធារណៈនេះទេ"],
    editMore: ["Edit", "បំពេញបន្ថែម"],
    apply: ["Apply", "ស្នើសុំ"],
    no: ["", "ល.រ"],
    identity: ["Identification", "លេខអត្តសញ្ញាណ"],
    company: ["Company", "ឈ្មោះក្រុមហ៊ុន"],
    service: ["Public Service", "សេវាសាធារណៈ"],
    deleteFormText: ["Do you want to delete this form application ?", "តើអ្នកពិតជាចង់លុបពាក្យស្នើសុំនេះមែនឬ ?"],
    APPLICATION_FORM_BHG197_title: ["Prakas of SMEs and Handicraft Establishment", "ប្រកាសបង្កើតសហគ្រាសធុនតូចនិងមធ្យម និងសិប្បកម្ម"],
    step1: ["1. Information", "១. ព័ត៌មានពាក្យស្នើសុំ"],
    step2: ["2. Review", "២. ត្រួតពិនិត្យឡើងវិញ"],
    step3: ["3. Payment", "៣. បង់ប្រាក់"],
    noDraft: ["You do not have any draft application forms.", "អ្នកមិនទាន់មានពាក្យស្នើសុំព្រាងទេ។"],
    noApp: ["You do not have any submitted application forms.", "អ្នកមិនទាន់មានពាក្យស្នើសុំបានដាក់ស្នើទេ។"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
}





// WEBPACK FOOTER //
// ./src/config/locale.js